export default __webpack_public_path__ + "b242ca898b687fbb744d3a6eaa888941.png";